import { useLang } from "./LangContext";
import { ChapterHead, FadeUp } from "./Reveal";

export default function Prefer() {
  const { t } = useLang();
  const p = t.prefer;

  return (
    <section id="tercih" className="section prefer" data-testid="prefer-section">
      <div className="wrap">
        <ChapterHead num={p.num} label={p.label} title={p.title} />
        <div className="prefer-body">
          {p.blocks.map((block, i) => (
            <FadeUp key={block.h3} delay={i * 0.04}>
              <article className="prefer-block" data-testid={`prefer-block-${i}`}>
                <h3 className="font-display">{block.h3}</h3>
                {block.paragraphs.map((par, j) => (
                  <p key={j}>{par}</p>
                ))}
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
